import { useQuery } from "hooks/useQuery";
import { getQuestions } from "services";

export const useQuestionnaire = (label) => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: ["questionnaire", label],
    queryFn: async () => {
      const response = await getQuestions({ label });
      return response;
    },
  });

  return {
    isLoading,
    questions: data || [],
    refetch,
  };
};
